import { render, staticRenderFns } from "./input-money.vue?vue&type=template&id=739a08fb&scoped=true&lang=pug&"
import script from "./input-money.vue?vue&type=script&lang=ts&"
export * from "./input-money.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "739a08fb",
  null
  
)

export default component.exports